var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_2784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83321 8.9568C2.1222 7.71698 1.77889 6.70461 1.57188 5.67841C1.26571 4.16069 1.96636 2.67811 3.12703 1.7321C3.61759 1.33229 4.17992 1.46889 4.47 1.9893L5.12488 3.16418C5.64397 4.09543 5.9035 4.56104 5.85202 5.05469C5.80055 5.54834 5.45053 5.9504 4.75048 6.75451L2.83321 8.9568ZM2.83321 8.9568C4.27238 11.4662 6.53088 13.726 9.0432 15.1668M9.0432 15.1668C10.283 15.8778 11.2954 16.2211 12.3216 16.4281C13.8393 16.7343 15.3219 16.0337 16.2679 14.873C16.6677 14.3825 16.5311 13.8201 16.0107 13.53L14.8358 12.8751C13.9045 12.356 13.4389 12.0965 12.9453 12.148C12.4516 12.1994 12.0496 12.5495 11.2455 13.2495L9.0432 15.1668Z",
    stroke: "#1CA8CB",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.12389C11.5674 5.57718 12.4228 6.43258 12.8761 7.5M10.9905 1.5C13.6434 2.26557 15.7343 4.35639 16.5 7.00922",
    stroke: "#1CA8CB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_2784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2151a380670645b8bd9c5126c8d76dfc.svg";
export { ForwardRef as ReactComponent };